<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path
      d="M11.06 20v-7.46c0-.37.1-.7.28-1.01.19-.31.44-.55.75-.7a9.4 9.4 0 0 1 4.15-1.01 9.57 9.57 0 0 1 4.14 1 1.9 1.9 0 0 1 1.04 1.71V20H11.05Zm5.18-10.82c-.72 0-1.32-.26-1.83-.77a2.5 2.5 0 0 1-.76-1.82c0-.7.25-1.32.76-1.83A2.5 2.5 0 0 1 16.24 4c.7 0 1.31.25 1.82.76.5.51.76 1.12.76 1.83 0 .7-.25 1.32-.76 1.82-.5.51-1.12.77-1.82.77ZM2.59 20v-5.42c0-.26.06-.5.2-.74.15-.22.33-.4.55-.5a6.91 6.91 0 0 1 3.02-.73 6.5 6.5 0 0 1 3.02.73 1.42 1.42 0 0 1 .76 1.24V20H2.59Zm3.76-7.87c-.51 0-.96-.19-1.32-.55-.37-.37-.56-.81-.56-1.33s.19-.96.56-1.33c.36-.36.8-.55 1.32-.55s.96.19 1.33.55c.37.37.56.81.56 1.33s-.2.96-.56 1.33c-.37.36-.8.55-1.33.55Z"
    />
  </svg>
</template>
<script>
export default {};
</script>
